<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Your Team</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <loading-panel v-if="loading"></loading-panel>
      <div v-else>
        <members :members="members" @getMembers="getMembers"></members>

        <hr>
    
        <users :members="members"></users>

        <hr>

        <observable-accounts></observable-accounts>
      </div>
    </b-container>
  </div>
</template>
<script>
import axios from "axios";
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import Members from "./Members";
import Users from "./Users";
import ObservableAccounts from "./ObservableAccounts";
import errorsMixin from "@/mixins/errors-mixin";

export default {
  mixins: [errorsMixin],
  components: {
    RouteBreadCrumb,
    Members,
    Users,
    ObservableAccounts
  },
  data: function() {
    return {
      loading: false,
      members: null
    }
  },
  computed: {
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    }
  },
  methods: {
    async getMembers() {
      axios.get(this.userRoute + "/members")
      .then(response => {
        this.members = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    }
  },
  mounted() {
    document.title = 'Your Team | ClarityNOW';
  },
  created() {
    this.getMembers();
  }
};
</script>